export function Color(type, indices) {
  return { type: type, indices: indices };
}
